<template>
  <div>
    <h3 class="img_text">商品图片：</h3>
    <div>
      <!-- 上传 -->
      <el-upload
        action="#"
        list-type="picture-card"
        :show-file-list="true"
        :http-request="upload"
        :on-preview="handlePictureCardPreview"
        :before-remove="handleRemove"
        :limit="3"
        :before-upload="beforeAvatarUpload"
      >
        <span v-if="uploadtype">
          <el-progress type="circle" :percentage="uploadnum"></el-progress>
        </span>
        <span v-else>
          <i class="el-icon-plus"></i>
        </span>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <!-- 内容参数 -->
    <div>
      <h3 class="img_text">商品描述：</h3>
      <table width="100%" border="1">
        <tr>
          <td>商品创建时间：</td>
          <td>{{ date }}</td>
          <td>物品名称：</td>
          <td><input type="text" v-model="ItemData.name" class="det" /></td>
          <td>物品描述：</td>
          <td><input type="text" v-model="ItemData.info" class="det" /></td>
        </tr>
        <tr>
          <td>物品规格：</td>
          <td><input type="text" v-model="ItemData.specifications" class="det" /></td>
          <td>来源票号：</td>
          <td><input type="text" v-model="ItemData.pNumber" class="det" /></td>
          <td>重量：</td>
          <td><input type="text" v-model="ItemData.weight" class="det" /></td>
        </tr>
        <tr>
          <td>价格：</td>
          <td><input type="text" v-model="ItemData.price" class="det" /></td>
          <td>商品状态：</td>
          <td>待上架</td>
          <td>商品创建人：</td>
          <td>{{ ItemData.usernames }}</td>
        </tr>
      </table>
    </div>

    <!-- 提交按钮 -->
    <div class="submit_tj">
      <el-button type="primary" @click="submitData">提交创建</el-button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
const COS = require("cos-js-sdk-v5");
const cos = new COS({
  SecretId: "AKID1pOghRu62i7G8j36sOddMoztXv2tUord", // 身份识别ID
  SecretKey: "YjdHfndCUVGjwta091cwzmIXVBbkcEag", // 身份秘钥
});
export default {
  name: "UpdateShop",
  data() {
    return {
      Imgs: [], //物品图片
      uploadnum: "", //上传进度
      uploadtype: false, //是否显示进度
      dialogVisible: false,
      dialogImageUrl: "",
      date: "", //今日日期
      ItemData: {
        name: "", //物品名称
        info: "", //物品描述
        specifications: "", //物品规格
        pNumber: "", //票号
        weight: "", //重量
        price: "",
        usernames: "", //当前登录的用户
      }, //商品信息
    };
  },
  methods: {
    //element 上传方法
    upload(res) {
      if (res.file) {
        // 执行上传操作
        cos.putObject(
          {
            Bucket: "changan-1259114000" /* 存储桶 */,
            Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
            Key: res.file.name /* 文件名 */,
            StorageClass: "STANDARD", // 上传模式, 标准模式
            Body: res.file, // 上传文件对象
            onProgress: (progressData) => {
              // 上传进度
              this.uploadnum = progressData.percent * 100;
            },
          },
          (err, data) => {
            // 上传成功之后
            if (data.statusCode == 200) {
              this.Imgs.push("https://" + data.Location);
              this.uploadtype = false;
            }
          }
        );
      }
    },
    handlePictureCardPreview(file) {
      console.log(file.url);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload() {
      this.uploadtype = true;
    },

    // 删除钩子
    handleRemove(file) {
      cos
        .deleteObject({
          Bucket: "changan-1259114000" /* 填入您自己的存储桶，必须字段 */,
          Region: "ap-guangzhou" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key: file.name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "文件删除成功",
            type: "success",
          });
        });
    },
    //提交数据
    submitData() {
      if (this.Imgs.length !== 0 && this.ItemData.price !== "") {
        //添加上传
        this.axios
          .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("shop_hd").add({data:{createTime:"${this.date}",imag:"${this.Imgs[0]}",image:"${this.Imgs[1]}",images:"${this.Imgs[2]}",
          ismarket:true,prick:"${this.ItemData.price}",specification:"${this.ItemData.specifications}",text:"${this.ItemData.name}",textt:"${this.ItemData.info}",
          ticketNum:"${this.ItemData.pNumber}",weight:"${this.ItemData.weight}",reviewer:false}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.$notify({
                title: "商品创建成功",
                message: "商品已成功上传",
                type: "success",
              });
              this.AddLogs();
              setTimeout(() => {
                this.$router.go(0);
              }, 1000);
            }
          });

        return;
      }
      this.$message.error("请将物品信息填写完整在上传");
      // this.
    },
    //上传日志
    AddLogs() {
      this.axios.post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: `db.collection("logs").add({data:{price:"${
          this.ItemData.price
        }",createDate:"${dayjs().format("YYYY-MM-DD HH:mm:ss")}",content:"${
          this.ItemData.name
        }",action:"创建商品",username:"${this.ItemData.usernames}"}})`,
      });
    },
  },
  created() {
    this.date = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    // this.userData.username
    setTimeout(() => {
      this.ItemData.usernames = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.img_text {
  margin: 20px 0;
}
table {
  border-collapse: collapse;
}
td input {
  border: none;
}
.det {
  width: 98%;
}
.submit_tj {
  margin-top: 50px;
}
</style>
